export const GOOGLE_TAG_MANAGER_ID = {
  NATURA: 'GTM-5FBM98D',
  AVON: 'GTM-MT3BNC2'
}